let l10n = {
    en: {
        // Buttons
        saveBtn: 'Save',
        cancelBtn: 'Cancel',
        courseSettings: {
            valueBetween: 'Must be a number between {0} and {1}.',
        },
        courseIcon: {
            invalidFile: 'Choose a PNG, JPG or SVG image smaller than {0}MB.',
        },
        topicSettings: {
            loadFailed: 'Could not open topic settings. Try again.',
        },
        assessmentMultipleChoice: {
            header: 'Multiple Choice',
            title: 'Create Multiple Choice Assessment',
            question: 'Enter question for multiple choice',
            listOptions: 'List with options',
            choiceTitle: 'Enter choice title',
            saveBtn: 'Save',
            errorMessage: 'Please choose the answer',
            errorMessage2: 'Please select at least one answer',
            hint: 'Select the correct answer',
        },
        assessmentMultipleResponse: {
            header: 'Multiple Response',
            title: 'Create Multiple Response Assessment',
            question: 'Enter question for multiple response',
            listOptions: 'List with options',
            choiceTitle: 'Enter choice title',
            saveBtn: 'Save',
            errorMessage: 'Please choose one or more the answers',
            selectAllThatApply: 'Select ALL That Apply',
            hint: 'Select ALL the correct answers',
        },
        assessmentMatching: {
            header: 'Matching',
            title: 'Create Matching Assessment',
            question: 'Enter question for matching',
            listOptions: 'List with matches',
            choiceTitle: 'Enter choice title',
            matchTitle: 'Enter match title',
            saveBtn: 'Save',
            errorMessage: 'Please match all items',
            hint: 'Drag each item to its correct pair',
        },
        assessmentSequence: {
            header: 'Sequence',
            title: 'Create Sequence Assessment',
            question: 'Enter question for sequence',
            listOptions: 'List with sequence',
            itemTitle: 'Enter item title',
            saveBtn: 'Save',
            hint: 'Drag the boxes in the correct order',
        },
        assessmentShortAnswer: {
            header: 'Short Answer',
            title: 'Create Short Answer Assessment',
            question: 'Enter question',
            inputAnswer: 'Enter short answer',
            answer: 'Short answer',
        },
        assessmentHotspotImage: {
            header: 'Hotspot Image',
            title: 'Create Hotspot Image Assessment',
            question: 'Enter question',
            addImage: 'Add image',
        },
        assessmentsCommon: {
            errorMessageForEmptyQuestion: 'Question must be not empty',
            errorMessageForOneOption: 'Fill at least two options',
            errorMessageForNotUniqueOption: 'Option must be unique',
            errorMessageFillBothPartMatching: 'Fill both parts of matching',
            errorMessageForOneMatches: 'Fill at least two matches',
        },
        // Course editor question dialog (fallback for `outline/question_editor.php`'s data-copy).
        questionEditor: {
            errorStem: 'Enter a question.',
            errorFewAnswers: 'Add at least two answers.',
            errorFewPairs: 'Add at least two pairs.',
            errorFewSteps: 'Add at least two steps.',
            errorDuplicate: 'This text is used twice.',
            errorHalfPair: 'Fill in both sides of the pair.',
            typeMultipleChoice: 'Multiple choice',
            typeMultipleResponse: 'Multiple response',
            typeMatching: 'Matching',
            typeSequence: 'Sequence',
            hintMultipleChoice: 'Select the correct answer',
            hintMultipleResponse: 'Select all correct answers',
            hintMatching: 'Match each item to its answer',
            hintSequence: 'Put the steps in the correct order',
            stemPlaceholder: 'Enter a question that demonstrates knowledge of this topic.',
            answerPlaceholder: 'Answer text\u2026',
            itemPlaceholder: 'Item\u2026',
            matchPlaceholder: 'Match\u2026',
            stepPlaceholder: 'Step\u2026',
            selectAllNote: '(Select all that apply)',
            correctTag: 'Correct',
            markCorrect: 'Mark as the correct answer \u2014 learners don\u2019t see this',
            markCorrectMulti: 'Mark as a correct answer \u2014 learners don\u2019t see this',
            removeRow: 'Remove',
            addAnswer: 'Add Answer',
            addPair: 'Add Pair',
            addStep: 'Add Step',
            moveUp: 'Move up',
            moveDown: 'Move down',
            preview: 'Preview',
            delete: 'Delete',
            done: 'Done',
            edit: 'Edit',
            submit: 'Submit',
            rightResult: 'Correct \u2014 nice work.',
            wrongChoice: 'Incorrect \u2014 the correct answer is highlighted.',
            wrongMulti: 'Incorrect \u2014 the correct answers are highlighted.',
            wrongMatching: 'Incorrect \u2014 the correct matches are shown.',
            wrongSequence: 'Incorrect \u2014 steps in the wrong position are marked.',
            correctMatch: 'Correct: {0}',
            correctPosition: 'Correct position: {0}',
            matchHint: 'Click an item, then click its match to connect them.',
            sequenceHint: 'Use the arrows to put the steps in the correct order.',
            noStem: '(No question written yet)',
            noItem: '(empty item)',
            noMatch: '(empty match)',
            noStep: '(empty step)',
            saved: 'Question saved.',
        },

        // Create custom course
        customCourse: {
            editOutline: 'Edit outline',
            exitEditing: 'Exit editing',
            preview: 'Preview',
            edit: 'Edit',
            remove: 'Delete',
            sameAsPre: 'Same as Pre-Assess',
            multipleChoice: 'Multiple choice',
            matching: 'Matching',
            imageHotspot: 'Image hotspot',
            sequence: 'Sequence',
            shortAnswer: 'Short answer',
            multipleResponse: 'Multiple response',
            addQuestion: 'Add Question',
            addLesson: 'Add Lesson',
            previewPreAssessment: 'Preview Pre-Assessment',
            previewTutorial: 'Preview Tutorial',
            previewPostAssessment: 'Preview Post-Assessment',
            addSkill: 'Add Skill',
            addTutorial: 'Add tutorial',
            correctStatus: 'Correct',
            wrongStatus: 'Incorrect',
            takeTutorial: 'Take tutorial',
            answers: 'answers',
            your: 'Your',
            choices: 'Choices',
            iDontKnow: 'I Don\'t Know',
            submit: 'Submit',
            enterModuleName: 'Enter module name',
            newModule: 'New Module',
            aiAssistant: 'AI assistant',
            uploading: 'Uploading',
            textLesson: 'Text lesson',
            correctAnswer: 'Correct answer',
            correctSequence: 'Correct sequence',
            correctMatching: 'Correct matching pairs',
            answer: 'Answer',
            // The name a blank course is created under (`CreateCustomCourseActions.createBlankCourse`).
            courseName: 'Untitled Course',
            lessonBuilder: 'Lesson Builder',
            // Outline authoring (course editor). `topic`/`topics` are the "N topics" sub-line under a
            // module name — twin of `Element/course_editor/outline/module_row.php`.
            newSkill: 'New Skill',
            topic: 'topic',
            topics: 'topics',
            saveError: 'Sorry, something went wrong. Please try again.',
            // Match skill_row.php labels when legacy editors rebuild the type controls.
            changeQuestionType: 'Change question type',
            changeLessonType: 'Change lesson type',
            // ── existing-content picker (course editor). Twins of the `.po` strings the picker and
            // the confirm dialog print into their elements' `data-copy`; these are the fallback when
            // an element did not print them.
            pickerTitleSkill: 'Add Existing Skills',
            pickerTitleModule: 'Add Existing Modules',
            pickerSubSkill: 'Copy skills from another course into {0}.',
            pickerSubModule: 'Copy whole modules from another course into {0}.',
            recentCourses: 'Recent Courses',
            pickerNoRecents: 'Search to find any course. Courses you copy from will show here.',
            pickerNoCourses: 'No courses match.',
            pickerMoreCourses: '{0} more \u2014 keep typing to narrow.',
            pickerPickCourse: 'Pick a course to browse its skills.',
            pickerNoSkills: 'No skills match.',
            loading: 'Loading\u2026',
            addSkills: 'Add Skills',
            addModules: 'Add Modules',
            addNSkill: 'Add {0} Skill',
            addNSkills: 'Add {0} Skills',
            addNModule: 'Add {0} Module',
            addNModules: 'Add {0} Modules',
            // Kind `lesson` (single-select): one skill's lesson linked to the target skill.
            pickerTitleLesson: 'Use an Existing Lesson',
            pickerSubLesson: 'Reuse another course\u2019s lesson for {0}.',
            pickerNoLessons: 'No lessons in this course.',
            useLesson: 'Use Lesson',
            lessonLinked: 'Lesson linked from {0}: {1}',
            skillsCopiedOne: '{0} skill copied to {1}',
            skillsCopiedMany: '{0} skills copied to {1}',
            modulesCopiedOne: '{0} module copied',
            modulesCopiedMany: '{0} modules copied',
            // ── delete confirm, one set per case (mockup `course-editor.dc.html`:1083-1118)
            titleSkill: 'Delete this skill?',
            titleModule: 'Delete this module?',
            titleBulkSkills: 'Delete {0} skills?',
            titleBulkModules: 'Delete selected modules?',
            verbSkill: 'Delete Skill',
            verbModule: 'Delete Module',
            verbSkills: 'Delete Skills',
            verbSelected: 'Delete Selected',
            msgSkillQuestion: '\u201C{0}\u201D has a question written on it. Deleting the skill deletes the question too.',
            msgSkillContent: '\u201C{0}\u201D has content set up on it. Deleting the skill removes it from the outline.',
            msgModuleOne: '\u201C{0}\u201D contains {1} skill. Deleting the module deletes it too, along with any questions and lessons set up on it.',
            msgModuleMany: '\u201C{0}\u201D contains {1} skills. Deleting the module deletes them too, along with any questions and lessons set up on them.',
            msgBulk: 'You\u2019re deleting {0}. {1}',
            msgBulkModulesOne: '1 module and everything in it \u2014 {0}',
            msgBulkModulesMany: '{0} modules and everything in them \u2014 {1}',
            msgBulkAuthoredOne: '1 of them has a question written on it, and that goes too.',
            msgBulkAuthoredMany: '{0} of them have a question written on it, and that goes too.',
            msgBulkPlain: 'This removes them from the outline.',
            // ── the Public bulk verb (course editor). Counts are what the server actually wrote.
            publicOnOne: '1 lesson is a public demo \u2014 anyone can open it without an account',
            publicOnMany: '{0} lessons are a public demo \u2014 anyone can open them without an account',
            publicOffOne: '1 lesson is no longer a public demo',
            publicOffMany: '{0} lessons are no longer a public demo',
            publicNothing: 'Nothing to change \u2014 the selection has no lessons in it',
        },
        questionsList: {
            'multiple_choice': 'Multiple choice',
            'multiple_response': 'Multiple response',
            'matching': 'Matching',
            'sequence': 'Sequence',
            'captivate': 'Simulation',
            'captivate_s3': 'Captivate S3',
            // The Lesson library, Simulation lessons only; the key stays for the menu handlers.
            'simulation': 'Lesson library',
            // 'short_answer': 'Short answer',
            // 'image_hotspot': 'Image hotspot',
        },
        lessonsList: {

            'cgeditor': 'Lesson builder',
            'existing_lesson': 'Existing Lesson',
            //'cgeditor_ai': 'Lesson builder AI',
            // 'cgeditor_ai_2': 'Lesson builder AI 2',
            // 'cgeditor_ai_3': 'Lesson builder AI 3',
            'video': 'Video',
            'document': 'Document',
           // 'scorm_upload': 'SCORM upload',
            'external_link': 'External Link',
            'library': 'Lesson library',
            'captivate': 'Captivate (ZIP)',
            'captivate_s3': 'Captivate S3',
            'simulation': 'Simulation',
        },
        lessonText: {
            'simulation_popup_title': 'Select Simulation lesson',
            'simulation_edit_title': 'Edit Simulation lesson',
            'simulation_assign_btn': 'Assign to topic',
            'simulation_update_btn': 'Update topic',
            'simulation_preview_btn': 'Preview',
            'simulation_upload_btn': 'Upload lesson ZIP',
            'simulation_filter_placeholder': 'Filter lessons…',
            'simulation_empty': 'No lessons uploaded yet',
            'simulation_uploading': 'Uploading and validating…',
            'simulation_blocks_label': 'Interactions:',
            'simulation_verdict_ok': 'Ready to add to the course',
            'simulation_verdict_warn': 'Ready to add — a few notes for the author',
            'simulation_verdict_error': 'This lesson can\'t be added yet — send it back to the author',
            'simulation_details_toggle': 'Show technical details',
            'simulation_frame_word': 'Frame',
            'simulation_frames_word': 'frames',
            'simulation_ia_word': 'assessment steps',
            'simulation_issue_bad_manifest': 'The lesson file is unreadable — ask the author for a fresh export',
            'simulation_issue_no_frames': 'The lesson has no frames',
            'simulation_issue_missing_file': 'a picture or audio file is missing from the delivery',
            'simulation_issue_no_audio': 'the narration audio is missing',
            'simulation_issue_no_screenshot': 'the screenshot is missing',
            'simulation_issue_no_size': 'screenshot size information is missing',
            'simulation_issue_bad_reference': 'refers to a frame that does not exist',
            'simulation_issue_unverified_vo': 'the narration text has not been verified by the author',
            'simulation_issue_bad_coords': 'a click target sits outside the screen',
            'simulation_issue_old_format': 'Made with an older lesson format — it still plays fine',
            'simulation_issue_pending_content': 'part of the content is still marked "pending" by the author',
            'simulation_issue_unsupported_block': 'uses an interaction this player does not support yet — that step will be skipped',
            'simulation_issue_extra_file': 'The delivery contains an unused file (safe to ignore)',
            'simulation_issue_steps_shrank': 'the steps list looks inconsistent',
            'existing_add_btn': 'Add lesson to course',
            'video_popup_title': 'Add video lesson',
            'document_popup_title': 'Add document lesson',
            'scorm_popup_title': 'Add SCORM lesson',
            'captivate_popup_title': 'Add Captivate simulation',
            'captivate_save_btn': 'Save and add lesson',
            'captivate_file_btn': 'Upload lesson package',
            'captivate_btn_under': 'Captivate export (.zip), max 200 MB.',
            'captivate_file_ready': 'Lesson package ready for upload.',
            'sim_linked': 'Linked lesson: {0}',
            'captivate_size_label': 'Window size',
            'captivate_size_small': 'Small',
            'captivate_size_large': 'Large',
            'captivate_question_label': 'Assessment question (optional)',
            'captivate_question_placeholder': 'Shown above the simulation when the assessment opens',
            'captivate_response_label': 'Expected answer (optional)',
            'captivate_response_placeholder': 'Shown after the simulation is completed',
            'captivate_s3_popup_title': 'Select Captivate from S3',
            'captivate_s3_edit_title': 'Edit Captivate from S3',
            'captivate_s3_selected_label': 'Selected:',
            'captivate_s3_assign_btn': 'Assign to topic',
            'captivate_s3_update_btn': 'Update topic',
            'captivate_s3_filter_placeholder': 'Filter in this folder…',
            'video_save_btn': 'Save and add video to lesson',
            'video_embed_placeholder': 'PLease add URL to video',
            'video_embed_label': 'Add URL to video',
            'video_embed_bottom_text': 'Add URL to video on YouTube or Vimeo.',
            'video_embed_error': 'Please add valid URL to video',
            'video_file_btn': 'Upload video file',
            'video_btn_under': `Add file in mp4, ogg, mov, webm, wmv. <br> File size not more than 500Mb`,
            'video_or': 'or',
            'video_wrong_url': 'Invalid URL. Please enter a valid YouTube or Vimeo URL',
            'video_upload_error': 'Error uploading video',
            'external_popup_title': 'Add external link lesson',
            'external_btn': 'Save and add website link to lesson',
        },
        // ── lesson dialogs on the learner modal (course editor). The head's kind label and the field
        // labels the skinned bodies print; type labels come from `lessonsList` (SCORM has none there).
        lessonDialog: {
            kind: 'Lesson',
            close: 'Close',
            clear: 'Clear',
            videoUrl: 'Video URL',
            documentUrl: 'Document URL',
            websiteUrl: 'Website URL',
            websiteInvalid: 'Invalid URL. Please enter a valid website URL.',
            uploadPdf: 'Upload PDF file',
            pdfHint: 'Add a file in PDF format. File size not more than 500Mb.',
            uploadScorm: 'Upload SCORM package',
            scormHint: 'Add a SCORM package in .zip format.',
            saveDocument: 'Save and add document to lesson',
            saveScorm: 'Save and add SCORM to lesson',
            typeScorm: 'SCORM',
        },
        // ── Lesson library (course editor, CG staff): the browser for new-format lessons, Simulation and
        // Dialog. Names and codes come from the server; `{0}`, `{1}` are filled by the dialog.
        lessonLibrary: {
            root: 'Library',
            crumbsLabel: 'Location in the library',
            search: 'Search all lessons…',
            filterFolder: 'Filter in this folder…',
            chipsLabel: 'Lesson type',
            chipAll: 'All',
            typeSimulation: 'Simulation',
            typeDialog: 'Dialog',
            badgeSimulation: 'SIM',
            badgeDialog: 'DIALOG',
            upload: 'Upload',
            uploadHint: 'One lesson per .zip: the lesson\'s folder with its .json and audio. Player files are not needed.',
            lessonsOne: '1 lesson',
            lessonsMany: '{0} lessons',
            liveMeta: 'v{0} live · {1}',
            usedBy: 'used by {0}',
            notPublished: 'not published',
            notPublishedLong: 'Not published yet. Make a version live in its details.',
            up: '.. (up one level)',
            details: 'Details',
            current: 'Current',
            selected: 'Selected:',
            selectedLive: '(v{0} live)',
            preview: 'Preview',
            assign: 'Assign to topic',
            uploadNewVersion: 'Upload new version',
            makeLive: 'Make live',
            live: 'live',
            loading: 'Loading lessons…',
            emptyRoot: 'No lessons in the library yet. Upload a Simulation lesson (.zip of its folder). Dialog lessons are published from Claude Code.',
            emptyFilter: 'No lessons match "{0}".',
            emptySearch: 'Nothing found for "{0}" in the library.',
            emptyType: 'No lessons of this type here.',
            searchLibrary: 'Search the whole library',
            legacy: 'Old-format lesson. Choose a library lesson to replace it.',
            languages: 'Languages',
            usedByHeading: 'Used by',
            usedByNone: 'No topic uses this lesson yet.',
            asAssessment: '· as assessment',
            topicsOne: '1 topic',
            topicsMany: '{0} topics',
            coursesOne: '1 course',
            coursesMany: '{0} courses',
            player: 'player {0}',
            warningsOne: '1 warning',
            warningsMany: '{0} warnings',
            confirmUpdate: 'This lesson is used by {0} in {1}. They will all get the new version.',
            confirmUpdateBtn: 'Choose .zip',
            confirmMakeLive: 'Make v{0} live? This lesson is used by {1} in {2}. They will all get v{0} the next time it opens.',
            confirmMakeLiveUnused: 'Make v{0} live?',
            uploading: 'Uploading {0}… {1}%',
            processing: 'Checking the lesson…',
            uploadDone: '"{0}" v{1} is uploaded and live.',
            warningsHeading: 'Notes for the author:',
            madeLive: 'v{0} is live now.',
            rowPreview: 'Preview',
            rowEdit: 'Edit',
            rowDelete: 'Delete',
            rowStart: 'Start Lesson',
        },
        moveActions: {
            'up': 'Move Up',
            'down': 'Move Down',
            'delete': 'Delete',
        },
        lessonNew: {
            'custom': 'New Skill',
            'existing': 'Existing Skill',
        },
        moduleNew: {
            'create': 'Create Module',
            'existing': 'Existing Module',
            'existing_course': 'Existing Course',
        },
        sessionNew: {
           // 'create_session': 'Create Session',
            'create': 'Create Module',
            'existing': 'Existing Module',
            'existing_course': 'Existing Course',
        },
        moduleTypeList: {
            '1': 'Verified Learning',
            '2': 'Skill Gaps',
            '3': 'Assessment',
            '4': 'Practice Test',
            '5': 'Lessons Only',
            '6': 'Lessons & Practice'
        },
        catalog: {
            quickReference: 'cheat sheet',
            course: 'course',
            quickReferences: 'Cheat Sheets',
            courses: 'courses',
            topics: 'Topics',
            noMatchingRecordFound: 'No matching record found',
            andNMore: 'and {0} more',
            selfEnrolled: 'Self Enrolled',
            selfAssigned: 'Self Assigned',
            enrolledBy: 'Enrolled By',
            started: 'Started',
            lastAccess: 'Last Access',
            completed: 'Completed',
            labelImprovement: 'Improvement',
            assignmentFrom: 'Assignment From',
            assigned: 'Assigned',
            messageNoDataFound: 'No data found',
            assignedBy: 'Assigned By',
            owner: 'Owner',
            user: 'user',
            users: 'users',
            skill: 'skill',
            skills: 'skills',
            module: 'module',
            modules: 'modules',
            progress: 'Progress',
            preAssess: 'Pre-Assess',
            postAssess: 'Post-Assess',
            improve: 'Improve',
            noModulesCompletedMsg: 'No Modules Completed',
            you: 'You',
            included: 'included',
            minutes: 'minutes',
            assignment: 'assignment',
            assignments: 'assignments',
            // ── The lookup picker (learning plan: Add Courses, Add Members). Twins of the `.po`
            // strings the panel prints into its `data-copy`; these are the fallback when an element
            // did not print them.
            added: 'Added',
            addCourses: 'Add Courses',
            addNCourse: 'Add {0} Course',
            addNCourses: 'Add {0} Courses',
            addUsers: 'Add Users',
            addNUser: 'Add {0} User',
            addNUsers: 'Add {0} Users',
            nUser: '{0} user',
            nUsers: '{0} users',
            nGroup: '{0} Group',
            nGroups: '{0} Groups',
            add: 'Add',
            coursesLoadFailed: 'Could not load courses. Please check your connection and try again.',
            usersLoadFailed: 'Could not load users. Please check your connection and try again.',
            // Course > Enrollments: the same picker in the enrolling verb.
            enroll: 'Enroll',
            enrollNUser: 'Enroll {0} User',
            enrollNUsers: 'Enroll {0} Users',
            enrolled: 'Enrolled',
            // The learner drawer's Enroll: the same picker counting courses, titled for the learner.
            enrollNCourse: 'Enroll {0} Course',
            enrollNCourses: 'Enroll {0} Courses',
            enrollLearnerName: 'Enroll {0}',
            // The admin's Group Visibility filter and the tile badge it reads.
            hidden: 'Hidden',
            noHiddenCourses: 'No hidden courses here.',
            noVisibleCourses: 'No visible courses here.'
        },
        textTopicResultNotification: {
            preAssessment: 'Pre-Assessment',
            postAssessment: 'Post-Assessment',
            quickAnswer: 'Quick Answer:',
            incorrect: 'Incorrect',
            correct: 'Correct',
            tryAgain: 'Try Again',
            retakeTutorial: 'Retake Tutorial',
            next: 'Next',
            fail: 'Fail',
            pass: 'Pass',
            complete: 'Complete',
            started: 'Started',
            incomplete: 'Incomplete',
            notStarted: 'Not Started',
            skip: 'Skip',
            startLesson: 'Start Lesson',
            close: 'Close',
            preAssessmentSubtitle: 'See if you already know this',
            postAssessmentSubtitle: 'Verify you’ve mastered this',
            takeLesson: 'Take Lesson',
            submitAnswer: 'Submit Answer',
        },
        pricePage: {
            billedAnnually: 'billed annually',
            billedMonthly: 'billed monthly',
        },
        popupClass: {
            goToNextImage: 'Go to next image',
            goToPreviousImage: 'Go to previous image',
        },
        aiAssistant: {
            createLesson: 'Create Lesson',
            aiAssistedContent: 'AI-Assisted Content',
            lessonNameLabel: 'Lesson name',
            addLessonName: 'Please add lesson name',
            additionalInstructions: 'Additional Instructions for assistant',
            promptHint: 'Additional instructions, approximate course length, tone, audience. Please keep it SHORT',
            proposedLesson: 'Proposed Lesson',
            adjustInputs: 'Adjust inputs',
            commitLesson: 'Commit Lesson',
            errorMessage1: 'Sorry, something went wrong... Please try again later.',
            errorMessage2: 'Sorry, something went wrong while processing the data... Please try again later.',
            errorMessage3: 'Sorry, something unexpected happened... Please try again later.',
            errorMessage4: 'Please add course name',
        },
        learningModeDropdown: {
            learningMode: 'Learning mode',
            preAssess: 'Pre-assess',
            lesson: 'Lesson',
            postAssess: 'Post-assess',
            verifiedLearning: 'Verified Learning',
            requireSkill: 'Require skill proficiency',
            required: 'Required',
            assessment: 'Assessment',
            measureSkills: 'Measure existing skills',
            skillGaps: 'Skill Gaps',
            addressSkill: 'Address skill deficiencies',
            optionalIfProficient: 'Optional if Proficient',
            practiceTest: 'Practice Test',
            certificationStudy: 'Certification study',
            lessonOnly: 'Lessons Only',
            noSkillAssessments: 'No skill assessments',
            resetProgress: 'Reset Progress',
            learnAndPractice: "Lessons & Practice",
            noPreAssessments: "No pre-assessments"
        },
        forms: {
            getQuoteMessage: 'Thank you for your request. We will contact you shortly',
            useWorkEmail: 'Please use work email instead personal',
        },
        formValidation: {
            required: 'Please fill out this field.',
            fullName: 'Please enter your first and last name.',
            email: 'Enter a valid email address (e.g. name@example.com).',
            phone: 'Enter at least 10 digits (numbers only).',
        },
        unsplash: {
            searchImage: 'Search image',
            loadMore: 'Load more',
            noResults: 'No images found. Try a different search.',
        },
        editor: {
            edit: 'Edit',
            remove: 'Delete',
            addTitle: 'Add a title',
            addImage: 'Add image',
            addNewItem: 'Add new item',
            enterQuestion: 'Enter question',
            questionLabel: 'Question',
            enterText: 'Enter text',
            isCorrect: 'Is correct',
            submit: 'Submit',
            addText: 'Add text',
            text: 'Text',
            image: 'Image',
            enterCaption: 'Enter caption',
            addNewImage: 'Add new image',
            heading: 'Heading',
            imageCaption: 'Image caption (optional)',
            deleteThisBlock: 'Are you sure you want to delete this block',
            yes: 'Yes',
            removeMarker: 'Remove marker',
            previous: 'Previous',
            next: 'Next',
            labelTitle: 'Label title',
            labelDescription: 'Label description',
            settings: 'Settings',
            moveBlockUp: 'Move block Up',
            moveUp: 'Move Up',
            moveBlockDown: 'Move block Down',
            moveDown: 'Move Down',
            cloneBlock: 'Copy block',
            clone: 'Copy',
            deleteBlock: 'Delete block',
            labeledImage: 'Labeled Image',
            list: 'List',
            paragraph: 'Paragraph',
            sortingActivity: 'Sorting Activity',
            statement: 'Statement',
            twoColumns: 'Two Columns',
            divider: 'Divider',
            accordion: 'Accordion',
            table: 'Table',
            imageText: 'Image Text',
            timeline: 'Timeline',
            gallery: 'Gallery',
            flashCard: 'Flashcard',
            matching: 'Matching',
            sorting: 'Sorting',
            choice: 'Choice',
            tabs: 'Tabs',
            addCard: 'Add card',
            enterCardText: 'Enter card text',
            deleteCard: 'Delete card',
            noCardsAdded: 'No cards added',
            replay: 'Replay',
            item: 'Item',
            column: 'Column',
            tabTitle: 'Tab title',
            enterTitle: 'Enter title',
            addSubheading: 'Add subheading',
            addHeading: 'Add heading',
            date: 'Date',
            addNewLabel: 'Add new label',
            labelSettings: 'Labels settings',
            layoutSettings: 'Layout settings',
            imageSettings: 'Image settings',
            uploadImage: 'Upload image',
            editImage: 'Edit image',
            caption: 'Caption',
            altText: 'Alt text',
            addCardTitle: 'Add card title',
            addSectionTitle: 'Add section title',
            sortingActivitySettings: 'Sorting Activity Settings',
            addCategory: 'Add category',
            changeImage: 'Change image',
            imageFromLibrary: 'Image from library',
            imageCaptionSetting: 'Image Caption',
            cutImage: 'Cut image',
            changeLayout: 'Change Layout',
            addLabel: 'Add label',
            changeImageDimension: 'Change image dimension',
            previewMode: 'Preview mode',
            fileSizeTooBig: 'File size is too big. Max file size is 10 mb',
            imageAlt: 'Image alt',
            apply: 'Apply',
            loading: 'Loading',
            wantSaveChanges: 'Do you want to save changes before close?',
            yesISaveIt: 'Yes, save it',
            noDontSave: 'No, don\'t save',
            savingProcess: 'Saving process',
            saved: 'Saved',
            saveLesson: 'Save lesson',
            video: 'Video',
            videoPlaceholder: 'Video caption (optional)',
            pasteYoutubeUrl: 'Please add URL to video',
            uploadVideoFile: 'Upload video file',
            videoUrlLabel: 'Add URL to video',
            videoUrlHint: 'Add URL to video on YouTube or Vimeo.',
            videoFileHint: 'Add file in mp4, ogg, mov, webm, wmv. File size not more than 500Mb',
            videoSettings: 'Video settings',
            replaceVideo: 'Replace video',
            videoFileSizeTooBig: 'File size is too big. Max file size is 500 MB',
            videoThumbnail: 'Thumbnail',
            uploadThumbnail: 'Upload thumbnail',
            removeThumbnail: 'Remove thumbnail',
            videoUploading: 'Uploading video...',
            videoUploadHint: 'You can continue editing. We\'ll notify you when it\'s ready.',
            videoUploadRetry: 'Please try again.',
        },
        courseManagement: {
            publishCourse: 'Publish Course',
            cloneCourse: 'Copy Course',
            archiveCourse: 'Archive Course',
            deleteCourse: 'Delete Course',
            stretch: 'Stretch',
            crop: 'Crop'
        },
        settings: {
            msgLogoRemoved: 'The account logo has been removed.',
            errorAccountName: 'Account name can\'t be empty',
            errorAccountTheme: 'Please add a valid value (6-digit hex code)',
            errorNotAllowedSymbols: 'Special characters is not allowed',
            errorSpacesNotAllowed: 'Spaces is not allowed'
        },
        assignments: {
            day: 'day',
            days: 'days',
            multiple: 'Multiple',
            add: 'Add',
            dueDate: 'Due Date'
        },
        pagination: {
            showing: 'Showing',
            of: 'of'
        },
        // Manage > Users table twin — the browser half of the markup the PHP elements under
        // `templates/Element/manage/users_table/` render server-side. Same words on both sides.
        manageUsers: {
            admin: 'Admin',
            inactiveBadge: 'Inactive',
            noLoginBadge: 'No Login',
            scorm: 'SCORM',
            scormUser: 'SCORM User',
            completed: 'completed',
            active: 'active',
            activeOne: 'active',
            inactive: 'inactive',
            inactiveOne: 'inactive',
            noLogin: 'no login',
            user: 'user',
            users: 'users',
            mixedModes: 'Mixed Learning Modes',
            mixedModesHint: 'Unlike scores can\'t be combined.',
            masteryModes: 'Mastery Modes',
            pickExpireDate: 'Pick an expiration date first.',
            noUsersMatch: 'No users match',
            noUsersYet: 'No users yet',
            noEnrollmentsMatch: 'No enrollments match',
            enrollment: 'enrollment',
            enrollments: 'enrollments',
            certificate: 'certificate',
            certificates: 'certificates',
            pickMode: 'Pick a mode to combine scores',
            enrolledBy: 'Enrolled by',
            via: 'via',
        },
        manageCourses: {
            draft: 'Draft',
            course: 'course',
            courses: 'courses',
            hidden: 'Hidden',
            noCoursesMatch: 'No courses match',
        },
        userPanel: {
            saveFailedMsg: 'Could not save. Please check your connection and try again.',
            firstNameErrorMsg: 'First name can\'t be empty.',
            lastNameErrorMsg: 'Last name can\'t be empty.',
            emailErrorMsg: 'Please enter a valid email address.',
            phoneErrorMsg: 'Phone number is not valid. Please add at least 10 digits. Special characters are not allowed.'
        },
        transferTrialUsers: {
            userAlreadyOnTheListMsg: 'This user is already on the list.',
            userTransferFailedMsg: 'User Transfer failed. Please try again.'
        },
        posts: {
            announcePlaceholder: 'Announce something to learners...',
            commentPlaceholder: 'Write a comment...',
            feedSettings: 'Feed Settings',
            postButton: 'Post',
            cancelButton: 'Cancel',
            saveButton: 'Save',
            sendButton: 'Send',
            justNow: 'Just now',
            minutesAgo: '{0}m ago',
            hoursAgo: '{0}h ago',
            yesterday: 'Yesterday',
            daysAgo: '{0}d ago',
            weeksAgo: '{0}w ago',
            learnersModePost: 'Learners can post and comment',
            learnersComment: 'Learners can only comment',
            adminsOnly: 'Only admins can post and comment',
            noFeed: 'No feed (disabled)',
            noPosts: 'No posts',
            onePost: 'post',
            multiplePosts: 'posts',
            oneComment: 'Comments',
            multipleComments: 'Comments',
            editPost: 'Edit',
            deletePost: 'Delete',
            deleteComment: 'Delete comment',
            savingText: 'Saving...',
            postContentEmpty: 'Please enter valid content before submitting.',
            postSavedSuccess: 'Post saved successfully',
            commentDeleteSuccess: 'Comment deleted successfully',
            postDeleteSuccess: 'Post deleted successfully',
            feedSettingsSaveSuccess: 'Saved successfully!',
            feedSettingsSaveError: 'Save failed. Please try again.',
            commentContentEmpty: 'Comment content cannot be empty.'
        },
        sidebarDescription: {
            placeholder: 'Describe this course',
            saveError: 'Save failed. Please try again.',
        },
    },
    es: {
        // Buttons
        saveBtn: 'Ahorrar',
        cancelBtn: 'Cancelar',
        courseSettings: {
            valueBetween: 'Debe ser un número entre {0} y {1}.',
        },
        courseIcon: {
            invalidFile: 'Elige una imagen PNG, JPG o SVG de menos de {0}MB.',
        },
        topicSettings: {
            loadFailed: 'No se pudieron abrir los ajustes del tema. Inténtalo de nuevo.',
        },
        assessmentMultipleChoice: {
            header: 'Opción multiple',
            title: 'Crear evaluación de opción múltiple',
            question: 'Ingrese la pregunta para la opción múltiple',
            listOptions: 'Lista con opciones',
            choiceTitle: 'Ingrese el título de la opción',
            saveBtn: 'Ahorrar',
            errorMessage: 'Por favor elige la respuesta',
            errorMessage2: 'Por favor seleccione al menos una respuesta',
            hint: 'Selecciona la respuesta correcta',
        },
        assessmentMultipleResponse: {
            header: 'Respuesta múltiple',
            title: 'Crear evaluación de respuesta múltiple',
            question: 'Ingrese la pregunta para la respuesta múltiple',
            listOptions: 'Lista con opciones',
            choiceTitle: 'Ingrese el título de la opción',
            saveBtn: 'Ahorrar',
            errorMessage: 'Por favor elija una o más respuestas',
            selectAllThatApply: 'Seleccione todas las que correspondan',
            hint: 'Seleccione TODAS las respuestas correctas',
        },
        assessmentMatching: {
            header: 'Pareo',
            title: 'Crear evaluación de coincidencia',
            question: 'Ingrese la pregunta para la coincidencia',
            listOptions: 'Lista con coincidencias',
            choiceTitle: 'Ingrese el título de la opción',
            matchTitle: 'Introduce el título del partido',
            saveBtn: 'Ahorrar',
            errorMessage: 'Por favor haga coincidir todos los elementos',
            hint: 'Arrastre cada elemento a su par correcto',
        },
        assessmentSequence: {
            header: 'Secuencia',
            title: 'Crear evaluación de secuencia',
            question: 'Ingrese la pregunta para la secuencia',
            listOptions: 'Lista con secuencia',
            itemTitle: 'Introduzca el título del artículo',
            saveBtn: 'Ahorrar',
            hint: 'Arrastra las cajas en el orden correcto',
        },
        assessmentShortAnswer: {
            header: 'Respuesta corta',
            title: 'Crear evaluación de respuesta corta',
            question: 'Introducir pregunta',
            inputAnswer: 'Introduzca una respuesta corta',
            answer: 'Respuesta corta',
        },
        assessmentHotspotImage: {
            header: 'Imagen de punto de acceso',
            title: 'Crear evaluación de imagen de punto de acceso',
            question: 'Introducir pregunta',
            addImage: 'Añadir imagen',
        },
        assessmentsCommon: {
            errorMessageForEmptyQuestion: 'La pregunta no debe estar vacía',
            errorMessageForOneOption: 'Complete al menos dos opciones',
            errorMessageForNotUniqueOption: 'La opción debe ser única',
            errorMessageFillBothPartMatching: 'Rellene ambas partes de la correspondencia',
            errorMessageForOneMatches: 'Rellene al menos dos coincidencias',
        },
        // Course editor question dialog (draft translation).
        questionEditor: {
            errorStem: 'Escribe una pregunta.',
            errorFewAnswers: 'Añade al menos dos respuestas.',
            errorFewPairs: 'Añade al menos dos pares.',
            errorFewSteps: 'Añade al menos dos pasos.',
            errorDuplicate: 'Este texto se repite.',
            errorHalfPair: 'Completa ambos lados del par.',
            typeMultipleChoice: 'Opción multiple',
            typeMultipleResponse: 'Respuesta múltiple',
            typeMatching: 'Pareo',
            typeSequence: 'Secuencia',
            hintMultipleChoice: 'Selecciona la respuesta correcta',
            hintMultipleResponse: 'Selecciona todas las respuestas correctas',
            hintMatching: 'Une cada elemento con su respuesta',
            hintSequence: 'Ordena los pasos correctamente',
            stemPlaceholder: 'Escribe una pregunta que demuestre el conocimiento de este tema.',
            answerPlaceholder: 'Texto de la respuesta\u2026',
            itemPlaceholder: 'Elemento\u2026',
            matchPlaceholder: 'Pareja\u2026',
            stepPlaceholder: 'Paso\u2026',
            selectAllNote: '(Selecciona todas las que correspondan)',
            correctTag: 'Correcta',
            markCorrect: 'Marcar como la respuesta correcta \u2014 los alumnos no lo ven',
            markCorrectMulti: 'Marcar como respuesta correcta \u2014 los alumnos no lo ven',
            removeRow: 'Quitar',
            addAnswer: 'Añadir respuesta',
            addPair: 'Añadir pareja',
            addStep: 'Añadir paso',
            moveUp: 'Subir',
            moveDown: 'Bajar',
            preview: 'Avance',
            delete: 'Eliminar',
            done: 'Listo',
            edit: 'Editar',
            submit: 'Enviar',
            rightResult: 'Correcto \u2014 buen trabajo.',
            wrongChoice: 'Incorrecto \u2014 la respuesta correcta está resaltada.',
            wrongMulti: 'Incorrecto \u2014 las respuestas correctas están resaltadas.',
            wrongMatching: 'Incorrecto \u2014 se muestran las parejas correctas.',
            wrongSequence: 'Incorrecto \u2014 los pasos en posición incorrecta están marcados.',
            correctMatch: 'Correcta: {0}',
            correctPosition: 'Posición correcta: {0}',
            matchHint: 'Haz clic en un elemento y luego en su pareja para unirlos.',
            sequenceHint: 'Usa las flechas para ordenar los pasos correctamente.',
            noStem: '(Aún no hay pregunta)',
            noItem: '(elemento vacío)',
            noMatch: '(pareja vacía)',
            noStep: '(paso vacío)',
            saved: 'Pregunta guardada.',
        },

        // Create custom course
        customCourse: {
            editOutline: 'Editar esquema',
            exitEditing: 'Salir de la edición',
            preview: 'Avance',
            edit: 'Editar',
            remove: 'Eliminar',
            sameAsPre: 'Igual que la Pre-evaluación',
            multipleChoice: 'Opción multiple',
            matching: 'Pareo',
            imageHotspot: 'Punto de acceso de imagen',
            sequence: 'Secuencia',
            shortAnswer: 'Respuesta corta',
            multipleResponse: 'Respuesta múltiple',
            addQuestion: 'Agregar pregunta',
            addLesson: 'Agregar lección',
            previewPreAssessment: 'Vista previa de la evaluación previa',
            previewTutorial: 'Tutorial de vista previa',
            previewPostAssessment: 'Vista previa de la evaluación posterior',
            addSkill: 'Agregar habilidad',
            addTutorial: 'Agregar tutorial',
            correctStatus: 'Correcta',
            wrongStatus: 'Incorrecta',
            takeTutorial: 'Tomar tutorial',
            answers: 'respuestas',
            your: 'Su',
            choices: 'Opciones',
            iDontKnow: 'No Sé',
            submit: 'Entregar',
            enterModuleName: 'Introduzca el nombre del módulo',
            newModule: 'Nuevo módulo',
            aiAssistant: 'Asistente de IA',
            uploading: 'Subiendo',
            textLesson: 'Lección de texto',
            correctAnswer: 'Respuesta correcta',
            correctSequence: 'Secuencia correcta',
            correctMatching: 'Corregir pares coincidentes',
            answer: 'Respuesta',
            courseName: 'Curso sin título', // draft
            lessonBuilder: 'Constructor de lecciones',
            // draft
            newSkill: 'Nueva habilidad',
            topic: 'tema',
            topics: 'temas',
            saveError: 'Lo sentimos, algo salió mal. Vuelve a intentarlo.',
            // draft
            changeQuestionType: 'Cambiar el tipo de pregunta',
            // draft
            changeLessonType: 'Cambiar el tipo de lección',
            // draft
            pickerTitleSkill: 'Agregar habilidades existentes',
            pickerTitleModule: 'Agregar módulos existentes',
            pickerSubSkill: 'Copia habilidades de otro curso a {0}.',
            pickerSubModule: 'Copia módulos completos de otro curso a {0}.',
            recentCourses: 'Cursos recientes',
            pickerNoRecents: 'Busca cualquier curso. Los cursos de los que copies aparecerán aquí.',
            pickerNoCourses: 'Ningún curso coincide.',
            pickerMoreCourses: '{0} más \u2014 sigue escribiendo para acotar.',
            pickerPickCourse: 'Elige un curso para ver sus habilidades.',
            pickerNoSkills: 'Ninguna habilidad coincide.',
            loading: 'Cargando\u2026',
            addSkills: 'Agregar habilidades',
            addModules: 'Agregar módulos',
            addNSkill: 'Agregar {0} habilidad',
            addNSkills: 'Agregar {0} habilidades',
            addNModule: 'Agregar {0} módulo',
            addNModules: 'Agregar {0} módulos',
            // Draft translation — picker kind `lesson`.
            pickerTitleLesson: 'Usar una lección existente',
            pickerSubLesson: 'Reutiliza la lección de otro curso para {0}.',
            pickerNoLessons: 'No hay lecciones en este curso.',
            useLesson: 'Usar lección',
            lessonLinked: 'Lección vinculada de {0}: {1}',
            skillsCopiedOne: '{0} habilidad copiada a {1}',
            skillsCopiedMany: '{0} habilidades copiadas a {1}',
            modulesCopiedOne: '{0} módulo copiado',
            modulesCopiedMany: '{0} módulos copiados',
            // draft
            titleSkill: '¿Eliminar esta habilidad?',
            titleModule: '¿Eliminar este módulo?',
            titleBulkSkills: '¿Eliminar {0} habilidades?',
            titleBulkModules: '¿Eliminar los módulos seleccionados?',
            verbSkill: 'Eliminar habilidad',
            verbModule: 'Eliminar módulo',
            verbSkills: 'Eliminar habilidades',
            verbSelected: 'Eliminar seleccionados',
            msgSkillQuestion: '\u201C{0}\u201D tiene una pregunta escrita. Al eliminar la habilidad también se elimina la pregunta.',
            msgSkillContent: '\u201C{0}\u201D tiene contenido configurado. Al eliminar la habilidad se quita del esquema.',
            msgModuleOne: '\u201C{0}\u201D contiene {1} habilidad. Al eliminar el módulo también se elimina, con sus preguntas y lecciones.',
            msgModuleMany: '\u201C{0}\u201D contiene {1} habilidades. Al eliminar el módulo también se eliminan, con sus preguntas y lecciones.',
            msgBulk: 'Vas a eliminar {0}. {1}',
            msgBulkModulesOne: '1 módulo y todo lo que contiene \u2014 {0}',
            msgBulkModulesMany: '{0} módulos y todo lo que contienen \u2014 {1}',
            msgBulkAuthoredOne: '1 de ellas tiene una pregunta escrita, y también se elimina.',
            msgBulkAuthoredMany: '{0} de ellas tienen una pregunta escrita, y también se eliminan.',
            msgBulkPlain: 'Esto las quita del esquema.',
            // draft
            publicOnOne: '1 lección es una demostración pública \u2014 cualquiera puede abrirla sin cuenta',
            publicOnMany: '{0} lecciones son una demostración pública \u2014 cualquiera puede abrirlas sin cuenta',
            publicOffOne: '1 lección ya no es una demostración pública',
            publicOffMany: '{0} lecciones ya no son una demostración pública',
            publicNothing: 'Nada que cambiar \u2014 la selección no contiene lecciones',
        },
        questionsList: {
            'multiple_choice': 'Opción multiple',
            'multiple_response': 'Respuesta múltiple',
            'matching': 'Pareo',
            'sequence': 'Secuencia',
            'captivate': 'Simulación',
            'captivate_s3': 'Captivate S3',
            'simulation': 'Biblioteca de lecciones',
            // 'short_answer': 'Respuesta corta',
            // 'image_hotspot': 'Punto de acceso de imagen',
        },
        lessonsList: {
            'cgeditor': 'Página',
            'video': 'Video upload',
            'document': 'Document Upload',
            //'scorm_upload': 'SCORM upload',
            'video_upload': 'Video Upload',
            'existing_lesson': 'Existing Lesson',
            'library': 'Biblioteca de lecciones',
            'captivate': 'Captivate (ZIP)',
            'captivate_s3': 'Captivate S3',
            'simulation': 'Simulación',
        },
        lessonText: {
            'simulation_popup_title': 'Seleccionar lección de simulación',
            'simulation_edit_title': 'Editar lección de simulación',
            'simulation_assign_btn': 'Asignar al tema',
            'simulation_update_btn': 'Actualizar tema',
            'simulation_preview_btn': 'Vista previa',
            'simulation_upload_btn': 'Subir ZIP de lección',
            'simulation_filter_placeholder': 'Filtrar lecciones…',
            'simulation_empty': 'Aún no hay lecciones subidas',
            'simulation_uploading': 'Subiendo y validando…',
            'simulation_blocks_label': 'Interacciones:',
            'simulation_verdict_ok': 'Lista para agregar al curso',
            'simulation_verdict_warn': 'Lista para agregar — algunas notas para el autor',
            'simulation_verdict_error': 'Esta lección aún no se puede agregar — devuélvala al autor',
            'simulation_details_toggle': 'Mostrar detalles técnicos',
            'simulation_frame_word': 'Cuadro',
            'simulation_frames_word': 'cuadros',
            'simulation_ia_word': 'pasos de evaluación',
            'simulation_issue_bad_manifest': 'El archivo de la lección es ilegible — pida al autor una nueva exportación',
            'simulation_issue_no_frames': 'La lección no tiene cuadros',
            'simulation_issue_missing_file': 'falta una imagen o un archivo de audio en la entrega',
            'simulation_issue_no_audio': 'falta el audio de narración',
            'simulation_issue_no_screenshot': 'falta la captura de pantalla',
            'simulation_issue_no_size': 'falta la información de tamaño de la captura',
            'simulation_issue_bad_reference': 'hace referencia a un cuadro que no existe',
            'simulation_issue_unverified_vo': 'el texto de narración no ha sido verificado por el autor',
            'simulation_issue_bad_coords': 'un objetivo de clic queda fuera de la pantalla',
            'simulation_issue_old_format': 'Hecha con un formato anterior — se reproduce bien',
            'simulation_issue_pending_content': 'parte del contenido sigue marcado como "pendiente" por el autor',
            'simulation_issue_unsupported_block': 'usa una interacción que este reproductor aún no admite — ese paso se omitirá',
            'simulation_issue_extra_file': 'La entrega contiene un archivo sin usar (puede ignorarse)',
            'simulation_issue_steps_shrank': 'la lista de pasos parece inconsistente',
            'existing_add_btn': 'Agregar lección al curso',
            'video_popup_title': 'Agregar lección de video',
            'document_popup_title': 'Agregar lección de documento',
            'scorm_popup_title': 'Agregar lección SCORM',
            'captivate_popup_title': 'Agregar simulación Captivate',
            'captivate_save_btn': 'Guardar y agregar lección',
            'captivate_file_btn': 'Subir paquete de lección',
            'captivate_btn_under': 'Exportación de Captivate (.zip), máx. 200 MB.',
            'captivate_file_ready': 'Paquete de lección listo para subir.',
            'sim_linked': 'Lección vinculada: {0}',
            'captivate_size_label': 'Tamaño de ventana',
            'captivate_size_small': 'Pequeño',
            'captivate_size_large': 'Grande',
            'captivate_question_label': 'Pregunta de evaluación (opcional)',
            'captivate_question_placeholder': 'Se muestra sobre la simulación cuando se abre la evaluación',
            'captivate_response_label': 'Respuesta esperada (opcional)',
            'captivate_response_placeholder': 'Se muestra después de completar la simulación',
            'captivate_s3_popup_title': 'Seleccionar Captivate desde S3',
            'captivate_s3_edit_title': 'Editar Captivate desde S3',
            'captivate_s3_selected_label': 'Seleccionado:',
            'captivate_s3_assign_btn': 'Asignar al tema',
            'captivate_s3_update_btn': 'Actualizar tema',
            'captivate_s3_filter_placeholder': 'Filtrar en esta carpeta…',
            'video_save_btn': 'Agregar video a la lección',
            'video_embed_placeholder': 'Agregue la URL del video',
            'video_embed_bottom_text': 'Agregue la URL del video en YouTube o Vimeo.',
            'video_embed_error': 'Agregue una URL válida al video',
            'video_file_btn': 'Subir archivo de video',
            'video_btn_under': 'Agregue un archivo en mp4, ogg, mov, webm, wmv. \/n Tamaño de archivo no superior a 500Mb',
        },
        // Draft translation — lesson dialogs on the learner modal (course editor).
        lessonDialog: {
            kind: 'Lección',
            close: 'Cerrar',
            clear: 'Borrar',
            videoUrl: 'URL del video',
            documentUrl: 'URL del documento',
            websiteUrl: 'URL del sitio web',
            websiteInvalid: 'URL no válida. Ingresa una URL de sitio web válida.',
            uploadPdf: 'Subir archivo PDF',
            pdfHint: 'Agrega un archivo en formato PDF. Tamaño máximo 500Mb.',
            uploadScorm: 'Subir paquete SCORM',
            scormHint: 'Agrega un paquete SCORM en formato .zip.',
            saveDocument: 'Guardar y agregar el documento a la lección',
            saveScorm: 'Guardar y agregar el SCORM a la lección',
            typeScorm: 'SCORM',
        },
        // Lesson library (course editor, CG staff) — see the English block.
        lessonLibrary: {
            root: 'Biblioteca',
            crumbsLabel: 'Ubicación en la biblioteca',
            search: 'Buscar en todas las lecciones…',
            filterFolder: 'Filtrar en esta carpeta…',
            chipsLabel: 'Tipo de lección',
            chipAll: 'Todas',
            typeSimulation: 'Simulación',
            typeDialog: 'Diálogo',
            badgeSimulation: 'SIM',
            badgeDialog: 'DIÁLOGO',
            upload: 'Subir',
            uploadHint: 'Una lección por .zip: la carpeta de la lección con su .json y su audio. No se necesitan los archivos del reproductor.',
            lessonsOne: '1 lección',
            lessonsMany: '{0} lecciones',
            liveMeta: 'v{0} activa · {1}',
            usedBy: 'usada en {0}',
            notPublished: 'sin publicar',
            notPublishedLong: 'Aún no está publicada. Active una versión en sus detalles.',
            up: '.. (subir un nivel)',
            details: 'Detalles',
            current: 'Actual',
            selected: 'Seleccionada:',
            selectedLive: '(v{0} activa)',
            preview: 'Vista previa',
            assign: 'Asignar al tema',
            uploadNewVersion: 'Subir nueva versión',
            makeLive: 'Activar',
            live: 'activa',
            loading: 'Cargando lecciones…',
            emptyRoot: 'Aún no hay lecciones en la biblioteca. Suba una lección de Simulación (.zip de su carpeta). Las lecciones de Diálogo se publican desde Claude Code.',
            emptyFilter: 'Ninguna lección coincide con "{0}".',
            emptySearch: 'No se encontró nada para "{0}" en la biblioteca.',
            emptyType: 'No hay lecciones de este tipo aquí.',
            searchLibrary: 'Buscar en toda la biblioteca',
            legacy: 'Lección de formato antiguo. Elija una lección de la biblioteca para reemplazarla.',
            languages: 'Idiomas',
            usedByHeading: 'Usada en',
            usedByNone: 'Ningún tema usa esta lección todavía.',
            asAssessment: '· como evaluación',
            topicsOne: '1 tema',
            topicsMany: '{0} temas',
            coursesOne: '1 curso',
            coursesMany: '{0} cursos',
            player: 'reproductor {0}',
            warningsOne: '1 aviso',
            warningsMany: '{0} avisos',
            confirmUpdate: 'Esta lección se usa en {0} de {1}. Todos recibirán la nueva versión.',
            confirmUpdateBtn: 'Elegir .zip',
            confirmMakeLive: '¿Activar la v{0}? Esta lección se usa en {1} de {2}. Todos recibirán la v{0} la próxima vez que se abra.',
            confirmMakeLiveUnused: '¿Activar la v{0}?',
            uploading: 'Subiendo {0}… {1} %',
            processing: 'Revisando la lección…',
            uploadDone: '"{0}" v{1} se subió y está activa.',
            warningsHeading: 'Notas para el autor:',
            madeLive: 'La v{0} está activa.',
            rowPreview: 'Avance',
            rowEdit: 'Editar',
            rowDelete: 'Eliminar',
            rowStart: 'Comienza la Lección',
        },
        moveActions: {
            'up': 'Ascender',
            'down': 'Mover hacia abajo',
            'delete': 'Borrar',
        },
        lessonNew: {
            'custom': 'Nueva habilidad',
            'existing': 'Habilidad existente',
        },
        moduleNew: {
            'create': 'Crear módulo',
            'existing': 'Módulo existente',
            'existing_course': 'Curso existente',
        },
        sessionNew: {
            'create_session': 'Crear sesión',
            //'create': 'Crear módulo',
            'existing': 'Módulo existente',
            'existing_course': 'Curso existente',
        },
        moduleTypeList: {
            '1': 'Aprendizaje verificado',
            '2': 'Brechas de habilidades',
            '3': 'Evaluación',
            '4': 'Examen de práctica',
            '5': 'Solo lecciones',
            '6': 'Lecciones y práctica'
        },
        catalog: {
            quickReference: 'referencia rápida',
            course: 'curso',
            quickReferences: 'Referencias rápidas',
            courses: 'cursos',
            topics: 'Temas',
            noMatchingRecordFound: 'No se encontró ningún registro coincidente',
            andNMore: 'y {0} más',
            selfEnrolled: 'Auto inscrito',
            selfAssigned: 'Auto asignado',
            enrolledBy: 'Inscrito por',
            started: 'Empezado',
            lastAccess: 'Último acceso',
            completed: 'Terminado',
            labelImprovement: 'Mejoría',
            assignmentFrom: 'Asignación de',
            assigned: 'Asignado',
            messageNoDataFound: '¡Datos no encontrados',
            assignedBy: 'Asignado por',
            owner: 'Dueño',
            user: 'usuario',
            users: 'usuarios',
            // draft
            skill: 'habilidad',
            skills: 'habilidades',
            module: 'módulo',
            modules: 'módulos',
            progress: 'Progreso',
            preAssess: 'Pre-eval',
            postAssess: 'Post-eval',
            improve: 'Mejorar',
            noModulesCompletedMsg: 'No hay módulos completados',
            you: 'Tú',
            included: 'incluida',
            minutes: 'minutos',
            assignment: 'asignación',
            assignments: 'asignaciones',
            // draft
            added: 'Agregado',
            addCourses: 'Agregar cursos',
            addNCourse: 'Agregar {0} curso',
            addNCourses: 'Agregar {0} cursos',
            addUsers: 'Agregar usuarios',
            addNUser: 'Agregar {0} usuario',
            addNUsers: 'Agregar {0} usuarios',
            nUser: '{0} usuario',
            nUsers: '{0} usuarios',
            nGroup: '{0} Grupo',
            nGroups: '{0} Grupos',
            add: 'Añadir',
            coursesLoadFailed: 'No se pudieron cargar los cursos. Comprueba tu conexión e inténtalo de nuevo.',
            usersLoadFailed: 'No se pudieron cargar los usuarios. Verifique su conexión e inténtelo de nuevo.',
            // draft
            enroll: 'Inscribir',
            enrollNUser: 'Inscribir {0} usuario',
            enrollNUsers: 'Inscribir {0} usuarios',
            enrolled: 'Inscrito',
            // draft
            enrollNCourse: 'Inscribir {0} curso',
            enrollNCourses: 'Inscribir {0} cursos',
            enrollLearnerName: 'Inscribir a {0}',
            // draft
            hidden: 'Oculto',
            noHiddenCourses: 'No hay cursos ocultos aquí.',
            noVisibleCourses: 'No hay cursos visibles aquí.'
        },
        textTopicResultNotification: {
            preAssessment: 'Pre-Evaluación',
            postAssessment: 'Evaluación Posterior',
            quickAnswer: 'Respuesta rápida:',
            incorrect: 'Incorrecto',
            correct: 'Correcto',
            tryAgain: 'Inténtalo de nuevo',
            retakeTutorial: 'Volver a Tutorial',
            next: 'Siguiente',
            fail: 'No Aprobado',
            pass: 'Aprobado',
            complete: 'Completo',
            started: 'Empezado',
            incomplete: 'Incompleto',
            notStarted: 'No empezado',
            skip: 'Omitido',
            startLesson: 'Iniciar lección',
            close: 'Cerrar',
            preAssessmentSubtitle: 'A ver si ya lo sabes',
            postAssessmentSubtitle: 'Verifica que dominas esto',
            takeLesson: 'Tomar Lección',
            submitAnswer: 'Enviar Respuesta',
        },
        pricePage: {
            billedAnnually: 'facturado anualmente',
            billedMonthly: 'facturado mensualmente',
        },
        popupClass: {
            goToNextImage: 'Ir a la siguiente imagen',
            goToPreviousImage: 'Ir a la imagen anterior',
        },
        aiAssistant: {
            createLesson: 'Crear lección',
            aiAssistedContent: 'Contenido asistido por IA',
            lessonName: 'Nombre de la lección',
            addLessonName: 'Por favor agregue el nombre de la lección',
            additionalInstructions: 'Instrucciones adicionales para asistente',
            promptHint: 'Instrucciones adicionales, duración aproximada del curso, tono, audiencia. Por favor, sea BREVE',
            proposedLesson: 'Lección propuesta',
            adjustInputs: 'Ajustar entradas',
            commitLesson: 'Lección de compromiso',
            errorMessage1: 'Lo sentimos, algo salió mal... Por favor, inténtalo de nuevo más tarde.',
            errorMessage2: 'Lo sentimos, algo salió mal al procesar los datos... Por favor, inténtalo de nuevo más tarde.',
            errorMessage3: 'Lo sentimos, ocurrió algo inesperado... Por favor, inténtalo de nuevo más tarde.',
            errorMessage4: 'Por favor agregue el nombre del curso',
        },
        learningModeDropdown: {
            learningMode: 'Modo de aprendizaje',
            preAssess: 'Pre-eval',
            lesson: 'Lección',
            postAssess: 'Post-eval',
            verifiedLearning: 'Aprendizaje verificado',
            requireSkill: 'Requiere dominio de habilidades',
            required: 'Requerida',
            assessment: 'Evaluación',
            measureSkills: 'Medir las habilidades existentes',
            skillGaps: 'Brechas de habilidades',
            addressSkill: 'Abordar las deficiencias de habilidades',
            optionalIfProficient: 'Opcional si es competente',
            practiceTest: 'Examen de práctica',
            certificationStudy: 'Estudio de certificación',
            lessonOnly: 'Solo lecciones',
            noSkillAssessments: 'Sin evaluaciones de habilidades',
            resetProgress: 'Restablecer progreso',
            learnAndPractice: "Lecciones y práctica",
            noPreAssessments: "Sin evaluaciones previas"
        },
        forms: {
            getQuoteMessage: 'Gracias por tu solicitud. Nos comunicaremos contigo en breve',
            useWorkEmail: 'Utilice el correo electrónico del trabajo en lugar del personal',
        },
        formValidation: {
            required: 'Rellena este campo.',
            fullName: 'Introduce tu nombre y apellido.',
            email: 'Introduce una dirección de correo electrónico válida (p. ej., nombre@ejemplo.com).',
            phone: 'Introduce al menos 10 dígitos (solo números).',
        },
        unsplash: {
            searchImage: 'Buscar imagen',
            loadMore: 'Carga más',
            noResults: 'No se encontraron imágenes. Pruebe otra búsqueda.',
        },
        editor: {
            edit: 'Editar',
            remove: 'Borrar',
            addTitle: 'Añade un titulo',
            addImage: 'Añadir imagen',
            addNewItem: 'Agregar ítem nuevo',
            enterQuestion: 'Introducir pregunta',
            questionLabel: 'Pregunta',
            enterText: 'Ingrese texto',
            isCorrect: 'Es correcta',
            submit: 'Entregar',
            addText: 'Añadir texto',
            text: 'Texto',
            image: 'Imagen',
            enterCaption: 'Ingresar subtítulo',
            addNewImage: 'Agregar nueva imagen',
            heading: 'Título',
            imageCaption: 'Título de imagen (opcional)',
            deleteThisBlock: '¿Estás seguro de que quieres eliminar este bloque',
            yes: 'Sí',
            removeMarker: 'Quitar marcador',
            previous: 'Previa',
            next: 'Próxima',
            labelTitle: 'Título de la etiqueta',
            labelDescription: 'Descripción de la etiqueta',
            settings: 'Ajustes',
            moveBlockUp: 'Mover bloque hacia arriba',
            moveUp: 'Ascender',
            moveBlockDown: 'Mover bloque hacia abajo',
            moveDown: 'Mover hacia abajo',
            cloneBlock: 'Clonar bloque',
            clone: 'Copy',
            deleteBlock: 'Eliminar bloque',
            labeledImage: 'Imagen etiquetada',
            list: 'Lista',
            paragraph: 'Párrafo',
            sortingActivity: 'Actividad de clasificación',
            statement: 'Declaración',
            twoColumns: 'Dos columnas',
            divider: 'Divisor',
            accordion: 'Acordeón',
            table: 'Mesa',
            imageText: 'Texto de la imagen',
            timeline: 'Línea de tiempo',
            gallery: 'Galería',
            flashCard: 'Tarjeta de memoria flash',
            matching: 'Pareo',
            sorting: 'Clasificación',
            choice: 'Elección',
            tabs: 'Pestañas',
            addCard: 'Agregar tarjeta',
            enterCardText: 'Introduce el texto de la tarjeta',
            deleteCard: 'Eliminar tarjeta',
            noCardsAdded: 'No se agregaron tarjetas',
            replay: 'Repetición',
            item: 'Artículo',
            column: 'Columna',
            tabTitle: 'Título de la pestaña',
            enterTitle: 'Introduce el título',
            addSubheading: 'Añadir subtítulo',
            addHeading: 'Agregar encabezado',
            date: 'Fecha',
            addNewLabel: 'Agregar nueva etiqueta',
            labelSettings: 'Configuración de etiquetas',
            layoutSettings: 'Opciones de diseño',
            imageSettings: 'Configuración de imagen',
            uploadImage: 'Cargar imagen',
            editImage: 'Editar imagen',
            caption: 'Subtítulo',
            altText: 'Texto alternativo',
            addCardTitle: 'Agregar título de tarjeta',
            addSectionTitle: 'Agregar título de sección',
            sortingActivitySettings: 'Ordenar la configuración de actividad',
            addCategory: 'Añadir categoría',
            changeImage: 'Cambiar imagen',
            imageFromLibrary: 'Imagen de la biblioteca',
            imageCaptionSetting: 'Captura de imagen',
            cutImage: 'Cortar imagen',
            changeLayout: 'Cambia el diseño',
            addLabel: 'Agregar etiqueta',
            changeImageDimension: 'Cambiar dimensión de imagen',
            previewMode: 'Modo de vista previa',
            fileSizeTooBig: 'El tamaño del archivo es demasiado grande. El tamaño máximo del archivo es 10 mb',
            imageAlt: 'Imagen alternativa',
            apply: 'Aplicar',
            loading: 'Cargando',
            wantSaveChanges: '¿Quieres guardar los cambios antes de cerrar',
            yesISaveIt: 'Si, guárdalo',
            noDontSave: 'No, no guardes',
            savingProcess: 'Proceso de ahorro',
            saved: 'Salvado',
            saveLesson: 'Guardar lección',
            video: 'Video',
            videoPlaceholder: 'Subtítulo del video (opcional)',
            pasteYoutubeUrl: 'Añade la URL del video',
            uploadVideoFile: 'Subir archivo de video',
            videoUrlLabel: 'Añadir URL al video',
            videoUrlHint: 'Añade la URL del video en YouTube o Vimeo.',
            videoFileHint: 'Añadir archivo en mp4, ogg, mov, webm, wmv. Tamaño máximo 500Mb',
            videoSettings: 'Configuración de video',
            replaceVideo: 'Reemplazar video',
            videoFileSizeTooBig: 'El tamaño del archivo es demasiado grande. El tamaño máximo del archivo es 500 MB',
            videoThumbnail: 'Miniatura',
            uploadThumbnail: 'Subir miniatura',
            removeThumbnail: 'Eliminar miniatura',
            videoUploading: 'Subiendo video...',
            videoUploadHint: 'Puedes seguir editando. Te avisaremos cuando esté listo.',
            videoUploadRetry: 'Por favor, inténtalo de nuevo.',
        },
        courseManagement: {
            publishCourse: 'Publicar curso',
            cloneCourse: 'Curso de clonación',
            archiveCourse: 'Curso de archivo',
            deleteCourse: 'Eliminar curso',
            stretch: 'Estirar',
            crop: 'Cultivo',
        },
        settings: {
            msgLogoRemoved: 'Se ha eliminado el logotipo de la cuenta.',
            errorAccountName: 'El nombre de la cuenta no puede estar vacío',
            errorAccountTheme: 'Agregue un valor válido (código hexadecimal de 6 dígitos)',
            errorNotAllowedSymbols: 'No se permiten caracteres especiales',
            errorSpacesNotAllowed: 'No se permiten espacios'
        },
        assignments: {
            day: 'día',
            days: 'días',
            multiple: 'Múltiple',
            add: 'Agregar',
            dueDate: 'Dos citas'
        },
        pagination: {
            showing: 'Mostrando',
            of: 'de'
        },
        // Manage > Users table twin. ⚠ DRAFT translations — to be reviewed by a Spanish speaker.
        manageUsers: {
            admin: 'Administrador',
            inactiveBadge: 'Inactivo',
            noLoginBadge: 'Sin inicio de sesión',
            scorm: 'SCORM',
            scormUser: 'Usuario SCORM',
            completed: 'terminado',
            active: 'activos',
            activeOne: 'activo',
            inactive: 'inactivos',
            inactiveOne: 'inactivo',
            noLogin: 'sin inicio de sesión',
            user: 'usuario',
            users: 'usuarios',
            mixedModes: 'Modos de aprendizaje mixtos',
            mixedModesHint: 'No se pueden combinar puntuaciones distintas.',
            masteryModes: 'Modos de dominio',
            pickExpireDate: 'Elija primero una fecha de expiración.',
            noUsersMatch: 'Ningún usuario coincide',
            noUsersYet: 'Aún no hay usuarios',
            noEnrollmentsMatch: 'Ninguna inscripción coincide',
            enrollment: 'inscripción',
            enrollments: 'inscripciones',
            certificate: 'certificado',
            certificates: 'certificados',
            pickMode: 'Elija un modo para combinar las puntuaciones',
            enrolledBy: 'Inscrito por',
            via: 'vía',
        },
        manageCourses: {
            draft: 'Borrador',
            course: 'curso',
            courses: 'cursos',
            hidden: 'Oculto',
            noCoursesMatch: 'Ningún curso coincide',
        },
        userPanel: {
            saveFailedMsg: 'No se pudo guardar. Comprueba tu conexión e inténtalo de nuevo.',
            firstNameErrorMsg: 'El nombre no puede estar vacío.',
            lastNameErrorMsg: 'El apellido no puede estar vacío.',
            emailErrorMsg: 'Por favor, introduce una dirección de correo electrónico válida.',
            phoneErrorMsg: 'El número de teléfono no es válido. Por favor, añada al menos 10 dígitos. No se permiten caracteres especiales.'
        },
        transferTrialUsers: {
            userAlreadyOnTheListMsg: 'Este usuario ya está en la lista.',
            userTransferFailedMsg: 'Error en la transferencia de usuario. Inténtalo de nuevo.'
        },
        posts: {
            announcePlaceholder: 'Anuncia algo a los estudiantes...',
            commentPlaceholder: 'Escribe un comentario...',
            feedSettings: 'Configuración del Feed',
            postButton: 'Publicar',
            cancelButton: 'Cancelar',
            saveButton: 'Guardar',
            sendButton: 'Enviar',
            justNow: 'Ahora mismo',
            minutesAgo: 'Hace {0}m',
            hoursAgo: 'Hace {0}h',
            yesterday: 'Ayer',
            daysAgo: 'Hace {0}d',
            weeksAgo: 'Hace {0}s',
            learnersModePost: 'Los estudiantes pueden publicar y comentar',
            learnersComment: 'Los estudiantes solo pueden comentar',
            adminsOnly: 'Solo los administradores pueden publicar y comentar',
            noFeed: 'Sin feed (deshabilitado)',
            noPosts: 'Sin publicaciones',
            onePost: 'publicación',
            multiplePosts: 'publicaciones',
            oneComment: 'Comentarios',
            multipleComments: 'Comentarios',
            editPost: 'Editar',
            deletePost: 'Eliminar',
            deleteComment: 'Eliminar comentario',
            savingText: 'Guardando...',
            postContentEmpty: 'Por favor ingrese contenido válido antes de enviar.',
            postSavedSuccess: 'Publicación guardada exitosamente',
            commentDeleteSuccess: 'Comentario eliminado exitosamente',
            postDeleteSuccess: 'Publicación eliminada exitosamente',
            feedSettingsSaveSuccess: '¡Guardado exitosamente!',
            feedSettingsSaveError: 'Error al guardar. Por favor intenta de nuevo.',
            commentContentEmpty: 'El contenido del comentario no puede estar vacío.'
        },
        sidebarDescription: {
            placeholder: 'Describe este curso',
            saveError: 'Error al guardar. Por favor intenta de nuevo.',
        },
    },
};

const siteCodeLang = document.documentElement.lang;
l10n = (typeof siteCodeLang !== 'undefined') ? l10n[siteCodeLang] : l10n.en;

export default l10n;
